import React, { useCallback, useEffect, useState } from "react";
import { useCheckList } from "../../../../hooks/useCheckList";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import AddIcon from "../../../../components/Common/SvgIcons/AddIcon";
import DownloadIconSmall from "../../../../components/Common/SvgIcons/CommonIcons/DownloadIconSmall";
import { useFetchData } from "../../../../hooks/useFetchData";
import {
  getSearchUsersActionHandler,
  getUsersListCSVActionHandler,
  getUsersStatusActionHandler,
  toggleUserStatusActionHandler,
  unlockUserAccountActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/userManagementActionHandler";
import { useDispatch } from "react-redux";
import classes from "./UserManagementTable.module.scss";
import { useLocation, useNavigate } from "react-router";
import { userManagement } from "../../../../utils/mainTabs/admin/userManagement/userManagement";
import Tooltip from "../../../Common/ToolTip/Tooltip";
import { useSelector } from "react-redux";
import getTenantName from "../../../../utils/getTenantName";
import { FormattedMessage } from "react-intl";
import Modal from "../../../Common/Modal/Modal";

const UserManagementTable = () => {
  const pageSize = 8;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const tenantName = getTenantName(dispatch, location);
  const commonState = useSelector((state) => state.commonReducer);
  const { colors, myProfile } = commonState;
  const { columns } = userManagement;
  const addUserPath = userManagement.addUserPath(tenantName);

  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { userManagementReducer } = adminStateReducer;
  const { unlockUserAccountLoader, toggleUserStatusLoader } =
    userManagementReducer;

  const [userStatusData, setUserStatusData] = useState([]);
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    searchQuery,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getSearchUsersActionHandler, pageSize);

  const getUsersStatus = useCallback(() => {
    dispatch(getUsersStatusActionHandler()).then((data) => {
      if (data) {
        setUserStatusData(data);
      }
    });
  }, [dispatch]);

  const handleGetUsersListCSV = () => {
    dispatch(getUsersListCSVActionHandler());
  };

  const handleUnlockUserAccount = (id) => {
    dispatch(unlockUserAccountActionHandler(id)).then((response) => {
      if (response) {
        const updatedData = data.map((row) => {
          return row.ID === id ? { ...row, IsLocked: false } : row;
        });
        setData(updatedData);
        setUpdatedData(updatedData);
      }
    });
  };

  const { handleCheckOne } = useCheckList("ID", data, setData, setUpdatedData);
  const [userActive, setUserActive] = useState("");
  const [userActiveID, setUserActiveID] = useState("");
  const [statusMsg, setStatusMsg] = useState("");
  const [btnLoader, setBtnLoader] = useState(false);

  const handleUserStatus = (e, id) => {
    let isUserActive = e?.target?.value === "true" ? true : false;
    setStatusMsg(e?.target?.value === "true" ? "deactivate" : "activate");
    setUserActive(isUserActive);
    setUserActiveID(id);
  };

  useEffect(() => {
    getUsersStatus();
  }, [getUsersStatus]);
  const handleShotclassStatus = () => {
    setBtnLoader(true)
    dispatch(toggleUserStatusActionHandler(userActiveID, userActive)).then(
      (response) => {
        if (response) {
          handleCheckOne(userActiveID);
          getUsersStatus();
          setUserActiveID(false);
          setBtnLoader(false)
        }
      }
    );
  };
  return (
    <div className={classes.userManagementTable}>
      <div className={classes.userManagementTable__header}>
        <div className={classes.userManagementTable__header__usersDetails}>
          {userStatusData[0] || 0} <FormattedMessage id="ACTIVE_TXT" /> ,{" "}
          {userStatusData[1] || 0} <FormattedMessage id="INACTIVE_TXT" /> &nbsp;
          <FormattedMessage id="DIST_USERS" />
        </div>
        <div className={classes.userManagementTable__header__userAction}>
          <Tooltip
            content={"Click here to download users list"}
            direction={"bottom"}
          >
            <div
              className={
                classes.userManagementTable__header__userAction__download
              }
              onClick={handleGetUsersListCSV}
            >
              <DownloadIconSmall fill={colors.theme} />
              Download Users List
            </div>
          </Tooltip>
          <div
            className={classes.userManagementTable__header__userAction__add}
            onClick={() => navigate(addUserPath)}
          >
            <AddIcon fill={colors.theme} />
            Add New User
          </div>
        </div>
      </div>
      <DataTable
        columns={columns(
          navigate,
          tenantName,
          myProfile?.ID,
          handleUnlockUserAccount,
          handleUserStatus,
          unlockUserAccountLoader,
          toggleUserStatusLoader
        )}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        loading={loading}
        uniqueFieldName={"ID"}
        fetchMoreData={handleCurrentPage}
        searchable
        searchQuery={searchQuery}
        setSearchQuery={handleSearchQuery}
      />
      <Modal
        handleSubmit={handleShotclassStatus}
        isOpen={userActiveID}
        heading={"Shotclasses Message"}
        toggle={() => handleUserStatus()}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGROUP_CANCELBTN" />}
        width={"46.2"}
        height={"26.9"}
        canClose
        loading={btnLoader}
      >
        <div className={classes.userManagementTable__Modal}>
          <div className={classes.userManagementTable__Modal__deleteModalTxt}>
            Are you sure, you want to {statusMsg} users?
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UserManagementTable;
